import { buttons } from 'copy/copy';
import React, { ReactElement } from 'react';
import { useTranslator, useLocale } from '@bluebeam/react-i18n';

const IndexFooter = (): ReactElement => {
  const { translate } = useTranslator(['index', 'buttons']);
  const { languageCode } = useLocale();

  const handleContactBtnClicked = (): void => {
    let code = languageCode.split('-')[0];
    if (code !== 'en') {
      if (code === 'sv') code = 'se';
      window.open(`https://support.bluebeam.com/${code}/contact/`, '_blank');
    } else {
      window.open('https://support.bluebeam.com/contact/', '_blank');
    }
  };

  return (
    <footer className="w100 bgd-black-1 index-footer">
      <div className="index__container">
        <div className="flex index-footer__content">
          <div className="index-footer__links font-size-4">
            <a
              className="mx2 inline-block cursor-pointer index-footer__link"
              href="https://www.bluebeam.com/legal"
            >
              {translate('index:footer.link.legal')}
            </a>
            |
            <a
              className="mx2 inline-block cursor-pointer index-footer__link"
              href="https://www.bluebeam.com/legal/terms-of-use"
            >
              {translate('index:footer.link.terms')}
            </a>
            |
            <a
              className="mx2 inline-block cursor-pointer index-footer__link"
              href="https://www.bluebeam.com/legal/privacy-policy"
            >
              {translate('index:footer.link.privacy')}
            </a>
            |
            <a
              className="mx2 inline-block cursor-pointer index-footer__link"
              href="https://www.bluebeam.com/legal/dmca-policy"
            >
              {translate('index:footer.link.dmca')}
            </a>
            |
            <a
              className="mx2 inline-block cursor-pointer index-footer__link"
              href="https://www.bluebeam.com/legal/cookie-declaration"
            >
              {translate('index:footer.link.cookies')}
            </a>
            |{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              className="mx2 inline-block cursor-pointer index-footer__link"
              // eslint-disable-next-line no-script-url
              href="javascript: Cookiebot.renew()"
            >
              {translate('index:footer.link.changeCookies')}
            </a>
            <p className="mt3">
              {translate('index:footer.copyrightText', {
                year: new Date().getFullYear(),
              })}
            </p>
          </div>
          <div className="index-footer__contact">
            <button
              className="btn-sm bold px3 py1 decoration-none flex-center"
              style={{
                backgroundColor: '#0083DB',
                borderRadius: '3px',
                minWidth: '109px',
                fontFamily: 'var(--body-font-family)',
              }}
              onClick={handleContactBtnClicked}
            >
              {translate('buttons:contact')}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default IndexFooter;
